import React from "react";
import "./ModernDial.css";

const ModernDial = ({ value }) => {
  const min = -90;
  const max = 90;
  const range = max - min;
  const percent = ((value - min) / range) * 100;

  // Offset oikealle ja vasemmalle, jotta -90 ja +90 mahtuvat gradientin päälle
  const OFFSET = 2; // prosenttia

  return (
    <div className="modern-dial-container">
      <div className="modern-scale">
        {[...Array(range + 1)].map((_, i) => {
          const label = min + i;
          //const left = (i / range) * 100;
          const relativePosition = (i / range) * (100 - OFFSET * 2) + OFFSET;

          const isZero = label === 0;
          const isMajor = label % 15 === 0;

          if (!isZero && !isMajor) return null; // näytetään vain 15 välein + 0

          return (
            <div
              key={label}
              className={`modern-mark ${isZero ? "zero" : ""}`}
              style={{ left: `${relativePosition}%` }}
            >
              <div className={`modern-tick ${isZero ? "zero-tick" : ""}`} />
              <div className="modern-label">{label}</div>
            </div>
          );
        })}
        <div className="modern-needle" style={{
          left: `calc(${OFFSET}% + ${(percent / 100) * (100 - OFFSET * 2)}%)`
        }} />
      </div>
      
      <div className="modern-value">{value.toFixed(2)}°</div>
    </div>
  );
};

export default ModernDial;
